<template>
  <div class="fund-info-container-temp" :id="scrollLink">
    <el-card :class="[infoTitle == ''?'no-title':'', 'box-card']" >
      <div slot="header" class="box-header">
        <div class="header-left">
          <!-- <i class="el-icon-s-management"></i> -->
          <span class="box-header-title">{{infoTitle}}</span>
        </div>
        <div class="header-right">
          <slot name="headerBtn"></slot>
        </div>
      </div>
      <div class="detail-content">
        <template v-for="(item, index) in contentConfig">
          <div class="detail-one" :key="`${item.prop}-${index}`" v-if="item.display && item.display == 'false'?false:true">
            <div class="detail-top" v-if="item.title">
              <div class="detail-title">
                {{item.title}}
                <span v-if="item.tips" class="title-tips">{{item.tips}}</span>
              </div>
            </div>
            <div class="detail-content">
              <slot :name="item.prop"></slot>
            </div>
          </div>
        </template>
        <slot></slot>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  name:'InfoContainer',
  data() {
    return {}
  },
  props: {
    /**
     * @param {String} infoTitle 页面信息块数组
     * @param {Array} contentConfig 页面信息块数组 [{title, prop, display}]
     * @param {Boolean} warnIcon 是否显示必填提示
     */
    infoTitle: {
      type: String,
      default: '项目信息'
    },
    contentConfig: {
      required: true,
      type: Array
    },
    warnIcon: {
      type: Boolean,
      default: false
    },
    // 默认跳转表示
    scrollLink: {
      type: String,
      default: 'infoHead'
    }
  }
}
</script>
<style lang="scss" scoped>
.fund-info-container-temp{
  .header-left{
    float: left;
  }
  .header-right{
    float: right;
  }
  /deep/ .el-card__body {
    padding: 0px !important;
  }
  /deep/.box-card{
    background-color: #fff;
    // border-radius: 10px;
    margin-bottom: 20px !important;
    // border: 1px solid #e9e9e9 !important;
    .el-card__header{
      // background-color: #f9f9f9 !important;
      padding: 10px 0 !important;
      border-bottom: none !important;
      overflow: hidden;
    }    
    .red-point{
      color: red;
    }
    .box-header{
      // background-color: #f9f9f9 !important;
      // padding: 10px 5px;
    }
    .box-header-title{
      color: rgb(51,51,51);
      font-weight: 400;
      font-size:16px;
      padding-left: 5px;
    }
    .box-header-warn{
      float: right;
      padding: 3px 0;
      color: #999;
      .red-point{
        color: red;
      }      
    }
    .detail-one{
      // padding: 20px 50px !important;
      .detail-top{
        padding: 10px 5px;
        .detail-title{
          color: #666;
          font-weight: 400;
          font-size: 16px;
          line-height: 28px;
          position: relative;
          .title-tips{
            font-weight: 400;
            color: #666666;
            font-size: 13px;
          }
        }
        .detail-title::before{
          content: '';
          width: 5px;
          background-color: #409EFF;
          height: 18px;
          position: absolute;
          left: -12px;
          top: 5px;
        }
      }
    }

  }
  /deep/.no-title{
    .el-card__header{
      height: 0 !important;
      padding: 0 !important;
    }
  }
}
</style>